import { Button } from "@website/ui-old/button";
import { useCta } from "@website/ui-old/datepicker/components/cta/cta.hook";
import styles from "@website/ui-old/datepicker/components/cta/cta.module.scss";
import { CtaPropertiesType } from "@website/ui-old/datepicker/components/cta/cta.types";
import { FC, memo } from "react";

const Cta: FC<CtaPropertiesType> = (properties) => {
  const { acceptButtonProperties, rejectButtonProperties } = useCta(properties);

  return (
    <div className={styles["container"]}>
      <Button {...rejectButtonProperties} className={styles["reject-button"]}>
        پاک کردن
      </Button>
      <Button {...acceptButtonProperties} className={styles["accept-button"]}>
        تایید
      </Button>
    </div>
  );
};

const CtaMemoized = memo(Cta);
/**
 * @deprecated please use @website/ui instead
 */
export { CtaMemoized /**
 * @deprecated please use @website/ui instead
 */ as Cta };
